import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { CLEARING_SUPER_ADMINISTRATOR } from './super-admin.guard';

const CLEARING_ADMINISTRATOR = 'CLEARING_ADMINISTRATOR';

export const adminGuard: CanActivateFn = async (route, state) => {
  const authenticationService = inject(AuthenticationService);
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);

  const userRoles = authenticationService.getUserRoles();
  const isAdministrator = userRoles.includes(CLEARING_ADMINISTRATOR) || userRoles.includes(CLEARING_SUPER_ADMINISTRATOR);

  if (!isAdministrator)
    messageService.add({
      severity: 'error',
      sticky: true,
      summary: translateService.instant('forbidden.summary'),
      detail: translateService.instant('forbidden.detail')
    });

  return isAdministrator;
};
